import React from 'react';
import { Button } from 'react-bootstrap';
import { AltNavBar } from '../components/NavBar';
import Localization from '../localization';

import '../styles/Endorsements.scss';

import config from '../config/web-site.json';

const strings = Localization.getStrings();

const { page, images } = config.endorsements.collision;

type CollisionProps = {
  scroller: (arg: string) => void;
}

const Collision: React.FC<CollisionProps> = (props) => {
  const { scroller } = props;

  return (
    <section id='collision' data-testid='collision-view'>
    <AltNavBar {...{ scroller, source: config.pages.collision.title }} className='collision-nav-bar'/>
      <div className='collage-header-collision'>
        <img src={require('../assets/img/collision_logo.png')} alt='Collision logo' />
        <Button variant='outline-primary' href={page} target='_blank' className='artist-page-button'>{strings.b_visit_artist_page}</Button>
      </div>
      <section className='collage'>
        {images.map((image, index) => (
        <div key={index} className='collage-item'>
          <img src={require(`../assets/img/collision/${image}`)} alt={`Collage item ${index + 1}`} />
        </div>
        ))}
      </section>
    </section>
  );
};

export default Collision;